import { Avatar, AvatarGroup, Box, IconButton, Typography } from '@mui/material';
import Images from '../../../../Assets/assetHelper';
import { useStyles } from '../styles';
import { useNavigate } from 'react-router-dom';

const YourGroupCard: React.FC<any> = (group) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const groupName: any = group?.groupName ? group?.groupName : "Title";
  const memberCount: any = group?.memberCount ? group?.memberCount : "-";
  const coverImage: any = group?.coverImage ? group?.coverImage : Images.Images.entreprenursOfKen42;
  const groupId: any = group?.id ? group?.id : "Title";
  const handleJoinClick = () => {
    navigate(`/groups/your-groups/${groupName}?id=${groupId}`);
  };
  console.log(group, "skdfjndkj");


  return (
<Box
  className={classes.GroupCard}
  sx={{ cursor: 'pointer' }}
  onClick={handleJoinClick}
>
  {/* Cover Image */}
  <Box position="relative">
    <img
      src={coverImage}
      alt="Discover Group"
      style={{
        width: '100%',
        height: 140,
        borderRadius: '10px 10px 0 0',
        objectFit: 'cover', // ✅ maintains aspect ratio
      }}
    />

    {/* Group Type */}
{group?.type?.toLowerCase() === 'private' && (
  <Typography
    variant="caption"
    sx={{
      position: 'absolute',
      top: 8,
      right: 8,
      backgroundColor: '#BFECFF',
      color: '#14516B',
      padding: '2px 6px',
      borderRadius: '8px',
      fontSize: '0.75rem',
    }}
  >
    {group?.type}
  </Typography>
)}

  </Box>

  {/* Group Info */}
  <Box
    component="div"
    sx={{
      padding: '10px 0 0 20px',
      '@media (max-width:626px)': { padding: '10px 0 0 5px !important' },
    }}
  >
    {/* Group Name */}
    <Typography className={classes.classSixteen}>{groupName}</Typography>

    {/* Member Avatars */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5, // ✅ space between avatars and text
        paddingTop: 1,
      }}
    >
      <AvatarGroup max={4} className={classes.cardAvatarGroup}>
        <Avatar
          alt="User"
          src={Images.Images.DefaultProfileImage}
          sx={{ width: 18, height: 18, fontSize: 12 }}
        />
      </AvatarGroup>

      <Typography sx={{ fontSize: 9, fontWeight: 400, color: '#fff' }}>
        {memberCount > 0 ? `+${memberCount} members` : 'No members yet'}
      </Typography>
    </Box>

    {/* Action */}
    <Box
      className={classes.cardActionContainer}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mt: 1,
      }}
    >
      <Typography sx={{ fontSize: 10.5, fontWeight: 500 }}>View details</Typography>
      <IconButton sx={{ marginRight: 1 }}>
        <img
          src={Images.Icons.ArrowForward}
          alt="ArrowForward"
          height={12}
          width={12}
        />
      </IconButton>
    </Box>
  </Box>
</Box>

  );
};

export default YourGroupCard;
